<script setup>
const appStore = useAppStore();

const closeDialog = () => {
  appStore.closeRewardsDialog();
};

const submitDialog = () => {
  appStore.closeRewardsDialog();
};
</script>

<template>
  <v-dialog
    v-model="appStore.rewardsDialog"
    class="tw-rounded-2xl !tw-z-[2010]"
    width="540"
    persistent
    scrim="#000"
    opacity="0.5"
  >
    <dialog-close-btn
      :icon="'mdi-close-circle-outline'"
      :iconSize="'32'"
      @onSubmitButton="closeDialog"
    />

    <battle-claims />
  </v-dialog>
</template>
